import authService from "../../services/AuthorizeService";
import { AuthenticationResultStatus } from "../../services/AuthorizeService";
import Constants from "../../helpers/Constants";
import React, { useState, useEffect } from "react";

const Login: React.FC<{ action: string }> = (props) => {
  const [message, setMessage] = useState("");
  useEffect(() => {
    switch (props.action) {
      case Constants.LoginActions.Login:
        login(getReturnUrl(null));
        break;
      case Constants.LoginActions.LoginCallback:
        processLoginCallback();
        break;
      case Constants.LoginActions.LoginFailed:
        const params = new URLSearchParams(window.location.search);
        const error = params.get(Constants.QueryParameterNames.Message)!;
        setMessage(error);
        break;
      default:
        throw new Error(`Invalid action '${props.action}'`);
    }
  }, [props.action]);

  const login = (returnUrl: string) => {
    authService.signIn({ returnUrl }).then((result) => {
      switch (result.status) {
        case AuthenticationResultStatus.Redirect:
          break;
        case AuthenticationResultStatus.Success:
          navigateToReturnUrl(returnUrl);
          break;
        case AuthenticationResultStatus.Fail:
          setMessage(result.message);
          break;
        default:
          throw new Error(`Invalid status result ${result.status}.`);
      }
    });
  };

  const processLoginCallback = () => {
    const url = window.location.href;
    authService.completeSignIn(url).then((result) => {
      switch (result.status) {
        case AuthenticationResultStatus.Redirect:
          throw new Error("Should not redirect.");
        case AuthenticationResultStatus.Success:
          navigateToReturnUrl(getReturnUrl(result.state));
          break;
        case AuthenticationResultStatus.Fail:
          setMessage(result.message);
          break;
        default:
          throw new Error(
            `Invalid authentication result status '${result.status}'.`
          );
      }
    });
  };

  const getReturnUrl = (state: any) => {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get(Constants.QueryParameterNames.ReturnUrl);
    if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
      throw new Error(
        "Invalid return url. The return url needs to have the same origin as the current page."
      );
    }
    const url =
      (state && state.returnUrl) || fromQuery || `${window.location.origin}/`;
    return url;
  };

  const navigateToReturnUrl = (returnUrl: string) => {
    window.location.replace(returnUrl);
  };

  if (!!message) {
    return <div>{message}</div>;
  } else {
    switch (props.action) {
      case Constants.LoginActions.Login:
        return <div>Processing</div>;
      case Constants.LoginActions.LoginCallback:
        return <div>Processing</div>;
      default:
        throw new Error(`Invalid action '${props.action}'`);
    }
  }
};

export default Login;
